import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.ReuploadPopupContent', {
    title: 'Reupload budget',
    updateButton: 'Update budget',
    description: `
        ApprovalMax allows to upload budgets in a pre-defined .csv file format. {learnMore}{br}{br}
        Files downloaded from the Xero Budget Manager can be uploaded without any adjustments.
    `,
    learnMore: 'Learn more',
    fileHeadline: 'Budget file',
    uploadFileButton: 'UPLOAD .CSV FILE',
    waitFileProcessing: 'Please wait until the file processing has finished.',
    noFileValidationError: 'Please upload a CSV file first.',
    editBudgetSuccessMessage: 'Budget edited',
    fileSizeExceedsTheLimit: 'The file size exceeds {size}.',
});
